import React from 'react'
import './style.css';
import { Modal, Table } from '../../../ui'
import { formatter } from '../../../utils/time-utils';
import {IRefund} from "../../../models/customer-data.interface";

interface RefundsModalInterface {
  refunds: IRefund[],
  showModal: boolean,
  handleOnClose: () => void
}

export default function BookingRefundsModal({ refunds, showModal, handleOnClose }: RefundsModalInterface) {
  const renderRefundsTable = () => {
    return (
      <Table colored={true} testId="test-refunds-table">
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Timestamp</Table.Th>
            <Table.Th>Amount</Table.Th>
            <Table.Th>Currency</Table.Th>
            <Table.Th>State</Table.Th>
          </Table.Tr>
          {
            refunds.map(refund => {

              return (
                <Table.Tr key={refund.timestamp} className="table-row">
                  <Table.Td style={{ maxWidth: '350px' }}>{refund?.timestamp ? formatter.format(new Date(refund.timestamp)) : ""}</Table.Td>
                  <Table.Td>{refund?.totalAmount?.grossAmount ? refund?.totalAmount?.grossAmount : "-"}</Table.Td>
                  <Table.Td>{refund?.totalAmount?.currency ? refund?.totalAmount?.currency : "-" }</Table.Td>
                  <Table.Td>{refund?.state ? refund?.state : "-" }</Table.Td>
                </Table.Tr>)
            })
          }
        </Table.Thead>
      </Table >
    )
  }

  return <Modal
    shown={showModal}
    onClose={handleOnClose}
    onConfirm={handleOnClose}
    buttonConfirmLabel="Ok"
    buttonConfirmText="Ok"
    title={`Refunds`}
    large={true}
    status='info'
    testId='test-refunds-table-modal'>
    {renderRefundsTable()}
  </Modal>
}
